import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shutterSpeed',
})
export class ShutterSpeedPipe implements PipeTransform {
  transform(value: number | string): string {
    if (!value) return '';
    return `1/${Math.round(1 / Number(value))}`; // Convert shutter speed to 1/x format
  }
}
